import React, { useState } from "react";

const FormikProps = ({ values, touched, errors }) => {
  const [showProps, setShowProps] = useState(false);
  return (
    <div>
      <div className="text-center">
        <button className="btn btn-light" type="button" onClick={() => setShowProps(!showProps)}>
          Develoment Only: Toggle Form Internals
        </button>
      </div>
      {showProps && (
        <div style={{ border: "dashed 1px #ccc", padding: 10, marginTop: 20 }}>
          <h5>Formik Internals</h5>
          <div>Values</div>
          <pre>{JSON.stringify(values, null, 2)}</pre>
          <hr />
          <div>Touched</div>
          <pre>{JSON.stringify(touched, null, 2)}</pre>
          <hr />
          <div>Errors</div>
          <pre>{JSON.stringify(errors, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default FormikProps;
